import { render, staticRenderFns } from "./WelcomeUser.vue?vue&type=template&id=681e9e91&scoped=true"
import script from "./WelcomeUser.vue?vue&type=script&lang=js"
export * from "./WelcomeUser.vue?vue&type=script&lang=js"
import style0 from "./WelcomeUser.vue?vue&type=style&index=0&id=681e9e91&prod&scoped=true&lang=css"
import style1 from "./WelcomeUser.vue?vue&type=style&index=1&id=681e9e91&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e9e91",
  null
  
)

export default component.exports